import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { NewsTicker } from "./components/NewsTicker";

// Pages
import HomePage from "./pages/HomePage";
import EventsPage from "./pages/EventsPage";
import UniversityPage from "./pages/UniversityPage";
import AMSKidsPage from "./pages/AMSKidsPage";
import CompassPage from "./pages/CompassPage";
import VendorsPage from "./pages/VendorsPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import FestivalOfTreesPage from "./pages/FestivalOfTreesPage";
import PublicEventsListPage from "./pages/PublicEventsListPage";
import PublicEventDetailPage from "./pages/PublicEventDetailPage";
import FestivalOfTreesDonatePage from "./pages/FestivalOfTreesDonatePage";
import FestivalOfTreesTermsPage from "./pages/FestivalOfTreesTermsPage";
import PublicProfilePage from "./pages/PublicProfilePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

// Component to show news ticker only on homepage
function NewsTickerWrapper() {
  const location = useLocation();
  // Only show on homepage
  if (location.pathname !== '/') return null;
  return <NewsTicker />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Navbar />
          <NewsTickerWrapper />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/happenings" element={<PublicEventsListPage />} />
              <Route path="/events/festival-of-trees" element={<FestivalOfTreesPage />} />
              <Route path="/festival-of-trees/donate-a-tree" element={<FestivalOfTreesDonatePage />} />
              <Route path="/events/festival-of-trees-2026/terms" element={<FestivalOfTreesTermsPage />} />
              <Route path="/events/:slug" element={<PublicEventDetailPage />} />
              <Route path="/profile/:id" element={<PublicProfilePage />} />
              <Route path="/university" element={<UniversityPage />} />
              <Route path="/university/ams-kids" element={<AMSKidsPage />} />
              <Route path="/compass" element={<CompassPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
